var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurcharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.6,4.4c-5.9-5.9-15.4-5.9-21.2,0l-43.7,43.7c-2.7-1.3-5.5-2.3-8.5-3L298.5,11.5 c-15.2-3.8-31.6,0.7-42.7,11.8L13.2,265.5c-17.5,17.5-17.5,46.1,0,63.6l169.7,169.7c17.5,17.5,46.1,17.5,63.6,0l242.2-242.6 c11.1-11.1,15.6-27.5,11.8-42.7L467,77.8c-0.7-3-1.8-5.8-3-8.5l43.7-43.7C513.5,19.8,513.5,10.3,507.6,4.4z M471.4,220.8 c1.3,5.1-0.2,10.5-3.9,14.2L225.3,477.6c-5.8,5.8-15.4,5.8-21.2,0L34.4,307.9c-5.8-5.8-5.8-15.4,0-21.2L276.9,44.5 c2.8-2.8,6.7-4.4,10.6-4.4c1.2,0,2.4,0.1,3.6,0.4l127.5,31.5l-36.1,36.1c-16.7-8-37.4-5-51.2,8.8c-17.5,17.5-17.5,46.1,0,63.6 c8.8,8.8,20.3,13.2,31.8,13.2c11.5,0,23-4.4,31.8-13.2c13.8-13.8,16.8-34.5,8.8-51.2l36.1-36.1L471.4,220.8z M373.8,159.4 c-5.8,5.8-15.4,5.8-21.2,0c-5.8-5.8-5.8-15.4,0-21.2c2.9-2.9,6.8-4.4,10.6-4.4c3.8,0,7.7,1.5,10.6,4.4l0,0l0,0 C379.6,144.1,379.6,153.6,373.8,159.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.5,180.6c-17.5-17.5-46.1-17.5-63.6,0c-17.5,17.5-17.5,46.1,0,63.6c17.5,17.5,46.1,17.5,63.6,0 C264.1,226.7,264.1,198.2,246.5,180.6z M225.3,223.1c-5.8,5.8-15.4,5.8-21.2,0s-5.9-15.4,0-21.2s15.4-5.8,21.2,0 C231.1,207.7,231.1,217.2,225.3,223.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.7,329.1c-17.6-17.6-46.1-17.6-63.6,0c-17.5,17.5-17.5,46.1,0,63.6c17.6,17.6,46.1,17.6,63.6,0 C285.3,375.2,285.3,346.7,267.7,329.1z M246.5,371.6c-5.9,5.9-15.4,5.9-21.2,0c-5.8-5.8-5.8-15.4,0-21.2c5.9-5.9,15.4-5.9,21.2,0 C252.4,356.2,252.4,365.7,246.5,371.6z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.7,274.4c-0.9-8.2-8.3-14.2-16.6-13.3l-190.9,21.2c-8.2,0.9-14.2,8.3-13.3,16.6 c0.9,7.7,7.3,13.3,14.9,13.3c0.6,0,1.1,0,1.7-0.1L322.4,291C330.7,290.1,336.6,282.7,335.7,274.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurcharge);
export default __webpack_public_path__ + "static/media/surcharge.666b03f86b6a41b6fed31544d4b3211b.svg";
export { ForwardRef as ReactComponent };